module.exports = __webpack_public_path__ + "static/img/banner2.c31b655.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone/banner2.jpg
// module id = mf6X
// module chunks = 2